var map = {
	"./run-with-cover": 305,
	"./run-with-cover.js": 305
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3118;



//////////////////
// WEBPACK FOOTER
// ./~/istanbul/lib/command/common ^\.\/.*$
// module id = 3118
// module chunks = 0